import { notification } from 'antd';
notification.config({
    placement: 'bottomRight',
    bottom: 50,
    duration: 3,
    prefixCls: 'oss-ui-notification',
});
export default notification;
